<template>

  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>

    <div class="modal-content">
      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Confirm Updates</p>
          <button
            class="delete"
            aria-label="close"
            @click="close()">
          </button>
        </header>

        <div class="modal-card-body">

          <table class="table is-fullwidth">
            <thead>
              <tr>
                <th>Field Changed</th>
                <th>Old Value</th>
                <th>New Value</th>
              </tr>
            </thead>
            <tbody>
              <tr 
                v-for="(value, label) in updatedTicket" 
                :key="label">
                <td>
                  {{ label.replace(/\_/g, " ") }}
                </td>
                <td>
                  <span v-html="originalTicket[label]"></span>
                </td>
                <td>
                  <span v-html="value"></span>
                </td>
              </tr>
            </tbody>
          </table>

          <label class="label">
            Update Comments
          </label>

          <v-text-area 
            placeholder="Provide comments for your update"
            v-model="comments">
          </v-text-area>

        </div>

        <footer class="modal-card-foot">

          <button 
            class="button is-primary" 
            @click.stop="saveChanges()">
            Save Updates
          </button>

          <button 
            class="button" 
            @click.stop="close()">
            Cancel
          </button>

        </footer>

      </div>
    </div>

  </div>

</template>

<script>
import VTextArea from '@/components/base/VTextArea'
import { mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean
    },
    ticketId: {
      type: [String, Number],
      required: true
    },
    updatedTicket: {
      type: Object
    },
    originalTicket: {
      type: Object
    }
  },
  components: {
    VTextArea
  },
  data() {
    return {
      comments: null
    }
  },
  methods: {
    ...mapActions("tickets", ["updateTicket"]),
    saveChanges() {
      let ticket = Object.assign({}, this.updatedTicket);
      ticket.comments = this.comments;

      this.updateTicket(
        { ticketId: this.ticketId, data: ticket, notify: true }
      ).then(
        () => this.close()
      )
    },
    close() {
      this.$emit('input', false);
    }
  }
}
</script>

<style scoped>
</style>